export const industries = [
  {
    id: "residential",
    title: "Residential Communities & HOA",
    description: "Private homes, gated communities, and apartment complexes",
    icon: "ri-home-4-line",
  },
  {
    id: "corporate",
    title: "Corporate & Commercial Buildings",
    description: "Office buildings, retail spaces, and business parks",
    icon: "ri-building-4-line",
  },
  {
    id: "healthcare",
    title: "Hospitals & Medical Facilities",
    description: "Hospitals, clinics, and medical office buildings",
    icon: "ri-hospital-line",
  },
  {
    id: "education",
    title: "Educational Institutions",
    description: "Schools, universities, and campus environments",
    icon: "ri-graduation-cap-line",
  },
  {
    id: "government",
    title: "Government & Municipal Facilities",
    description: "Government buildings, courthouses, and public facilities",
    icon: "ri-government-line",
  },
  {
    id: "nonprofit",
    title: "Nonprofits & Faith-Based Organizations",
    description: "Charitable organizations, churches, and community centers",
    icon: "ri-heart-3-line",
  },
  {
    id: "high-net-worth",
    title: "High-Net-Worth Individuals",
    description: "Personal security and family protection services",
    icon: "ri-vip-crown-line",
  },
  {
    id: "entertainment",
    title: "Entertainment & VIP Events",
    description: "Film sets, studios, celebrity events, and premieres",
    icon: "ri-movie-line",
  },
  {
    id: "construction",
    title: "Construction & Industrial Sites",
    description: "Active building projects and industrial facilities",
    icon: "ri-tools-line",
  },
  {
    id: "retail",
    title: "Shopping Centers & Retail Stores",
    description: "Malls, outlets, and individual retail locations",
    icon: "ri-store-2-line",
  },
  {
    id: "concerts",
    title: "Concerts & Festivals",
    description: "Large-scale public music and cultural events",
    icon: "ri-music-2-line",
  },
  {
    id: "sports",
    title: "Sporting Events",
    description: "Stadiums, arenas, and athletic competitions",
    icon: "ri-trophy-line",
  },
];